import { Guid } from '@web/utils';
import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminBoxCosmeticRequest {
  @jsonMember(String)
  public readonly id!: Guid;

  public constructor(
    private readonly data: {
      id: Guid;
    },
  ) {
    this.id = this.data.id;
  }
}
